import { Subject, Observable, of } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { NotifMessageService } from "./notifmessage.service";
import { catchError, map } from "rxjs/operators";
import { Items } from "../models/items";
import { Supplier } from "../models/supplier";


@Injectable({ providedIn: 'root' })
export class SupplierService {

    supplierGlobalInfo: any;
    supplierContactInfo: any;
    isSaveNeeded: boolean = false;

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService
    ) { }

    // used to rest params form and searchResult : events from search-suppler-by-merchant and
    // search-suppler-by-supplier components and action is performed in app-supplier-page component;
    resetResultsSubject = new Subject<any[]>();

    supplierSubject = new Subject<any[]>();
    supplierSubject1 = new Subject<any[]>();
    supplierSubjectPager = new Subject<Items<Supplier>>();

    getSupplierGlobalInfo() {
        return this.supplierGlobalInfo;
    }

    setSupplierGlobalInfo(supplierGlobalInfo) {
        this.supplierGlobalInfo = supplierGlobalInfo;
        this.isSaveNeeded = true;
        this.supplierSubject.next([this.isSaveNeeded]);
    }

    getSupplierContactInfo() {
        return this.supplierContactInfo;
    }

    setSupplierContactInfo(supplierContactInfo) {
        this.supplierContactInfo = supplierContactInfo;
        this.isSaveNeeded = true;
        this.supplierSubject.next([this.isSaveNeeded]);
    }

    emitSuppliersBySupplier(criteria) {
        this.supplierSubject.next(criteria);
    }

    emitResetResult(res) {
        this.resetResultsSubject.next(res);
    }

    emitSuppliersByMerchant(suppliers) {
        this.supplierSubject1.next(suppliers);
    }

    emitSupplierPager(suppliers) {
        this.supplierSubjectPager.next(suppliers);
    }

    getAllSuppliers(): Observable<Items<Supplier>> {
        let pager: {} = [];
        pager["sort"] = "id,ASC";
        pager["size"] = 200;

        return this.findByCriteria({}, pager, false);
    }

    getSupplierById(id): Observable<Supplier> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlSupplier}/${id}`).pipe(catchError(err => {
            console.log("error byid", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SUPPLIER_API', err);
            let emptyItem = new Supplier();
            emptyItem.name = "N/A";
            return of(emptyItem);
        }));
    }

    getSuppliersById(listSuppliersId): Observable<any> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlSupplier}/suppliersid?ids=${listSuppliersId}`).pipe(catchError(err => {
            console.log("error byids", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SUPPLIER_API', err);
            return of(null);
        }));
    }

    deleteSupplier(id): Observable<any> {
        return this.http.delete<any>(`${this.configService.config.urlAPI.urlSupplier}/${id}`).pipe(catchError(err => {
            console.log("error delete", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SUPPLIER_API', err);
            return of(null);
        }));
    }

    updateSupplier(): Observable<any> {
        let newSupplier = { ...this.getSupplierGlobalInfo(), ...this.getSupplierContactInfo() };
        return this.http.put<Supplier>(this.configService.config.urlAPI.urlSupplier, newSupplier).pipe(catchError(err => {
            console.log("error update", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SUPPLIER_API', err);
            return of(null);
        }));
    }

    createSupplier(newSupplier): Observable<any> {
        return this.http.post<Supplier>(this.configService.config.urlAPI.urlSupplier, newSupplier).pipe(catchError(err => {
            console.log("error create", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SUPPLIER_API', err);
            return of(null);
        }));
    }

    isExternalRefExists(externalRef: string): Observable<boolean> {
        if (externalRef === '') {
            return of(false);
        }
        const criteria = {
            'externalRef': externalRef
        }
        return this.findByCriteria(criteria, {}, true).pipe(map(res => { 
            return res.content.length > 0 && res.content.filter((supplier) => supplier.externalRef === externalRef).length > 0;
        }));
    }

    
    isEmailExists(email: string): Observable<boolean> {
        if (email === '') {
            return of(false);
        }
        const criteria = {
            'contact.email': email
        }
        return this.findByCriteria(criteria, {}, false).pipe(map(res => { 
            return res.content.length > 0 && res.content.filter((supplier) => supplier.contact.email === email).length > 0
        }));
    }

    findByCriteria(criteria, pager, isDeletedIncluded:boolean): Observable<Items<Supplier>> {
        let params = {};
        Object.assign(params, pager, criteria, {includeDeleted:isDeletedIncluded});

        return this.http.get<any>(this.configService.config.urlAPI.urlSupplier, { params: params }).pipe(catchError(err => {
            console.log("error findBYCriteria", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SUPPLIER_API', err);
            let emptyList = new Items<Supplier>();
            emptyList.content = [];
            return of(emptyList);
        }));
    }

}